module.exports = __webpack_public_path__ + "img/zfb_3.b70eb7f7.png";